import React, { useContext, useEffect, useState } from "react";
import ParameterContext from "../context/parameter/parameterContext";
import { IoIosCloseCircleOutline } from "react-icons/io";
import TradathonContext from "../context/tradathon/TradathonContext";
import { withRouter } from "react-router-dom";
import styles from "../styles/LiveCard.module.css";
import { formatPrice } from "../helpers/format";
import NumberFormat from "react-number-format";
import image from "../assets/images/bear.svg";
import Countdown from "react-countdown";
import Badge from "./Badge";
import { BiShareAlt } from "react-icons/bi";
import authContext from "../context/auth/authContext";
import { useWindowSize } from "react-use";
import { toast } from "react-toastify";
import Loader from "../components/Loader";
const PublicContestModal = ({ d, visible, onClose, winnings }) => {
  const { createRoomData, setUserJoined } = useContext(TradathonContext);
  const { width } = useWindowSize();

  const [terms, setTerms] = useState(false);

  useEffect(() => {
    setTerms(false);
  }, []);
  useEffect(() => {
    if (createRoomData && createRoomData.data) {
      history.push(
        `/tradathon/addcoins?rmid=${createRoomData.data.roomMember._id}&rid=${createRoomData.data.roomMember.rid}`
      );
    }
    //eslint-disable-next-line
  }, [createRoomData]);
  const { tradathonLoading, joinRoom } = useContext(TradathonContext);
  const { userData } = useContext(authContext);
  const { listingTab } = useContext(ParameterContext);
  const {
    noOfPlayers,
    startTime,
    entryFees,
    prize,
    rtype,
    rname,
    joinedMembers,

    history,
    endTime,
    rstatus,
    rcode,
    isPaid,
  } = d;
  const handleTerms = (e) => {
    setTerms(e.target.checked);
  };
  const handleJoin = () => {
    if (!terms) {
      toast.error("Please accept terms and conditions", { autoClose: 6000 });
    } else {
      joinRoom({
        rcode: d.rcode,
        pid: userData.profile_data._id,
        from: "publicContestModal",
      });
    }
  };
  const renderer = ({ completed, formatted }) => {
    let { days, hours, minutes, seconds } = formatted;

    if (completed) {
      // Render a completed state
      return <span>Contest Started</span>;
    } else {
      // Render a countdown
      let bool = false;
      if (days === "00" && hours === "00" && minutes === "00") {
        bool = true;
      }

      return (
        <>
          {rstatus === 0 ? (
            <p style={{ margin: "5px 0" }}>Starts In</p>
          ) : rstatus === 1 ? (
            <p style={{ margin: "5px 0" }}>Ends In</p>
          ) : (
            <></>
          )}
          <p className="timer" style={{ fontSize: "12px", padding: "2px" }}>
            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : rstatus === 1 && "#45AA43",
                }}
              >
                {days}{" "}
              </span>
              <span className="timeLabel">days</span>
            </span>

            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : rstatus === 1 && "#45AA43",
                }}
              >
                {hours}
              </span>
              <span className="timeLabel">hours</span>
            </span>

            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : rstatus === 1 && "#45AA43",
                }}
              >
                {minutes}
              </span>
              <span className="timeLabel">minutes</span>
            </span>

            <span className="timeB">
              <span
                className="time"
                style={{
                  background: bool
                    ? "rgb(233, 56, 72)"
                    : rstatus === 1 && "#45AA43",
                }}
              >
                {seconds}
              </span>
              <span className="timeLabel">seconds</span>
            </span>
          </p>
        </>
      );
    }
  };
  return (
    <div className="Register">
      <div
        className="Login__container"
        style={{
          width: width > 900 ? "60%" : "100%",
          padding: width > 900 ? "20px" : 0,
          bottom: "10%",
          overflow: "auto",
        }}
      >
        <div
          style={{ textAlign: "right" }}
          onClick={() => {
            onClose();
            setUserJoined();
          }}
        >
          <IoIosCloseCircleOutline size={40} style={{ cursor: "pointer" }} />
        </div>

        <div className={styles.Tradathon__LiveCard}>
          <div className={styles.Tradathon__LiveCard_children}>
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <p>Prize :{prize}</p>
            )}
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <p style={{ color: "#717171" }}>
                {noOfPlayers - joinedMembers} left
              </p>
            )}
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <p style={{ color: "#E8BD6E" }}>{rtype}</p>
            )}
          </div>
          <div className={styles.Tradathon__LiveCard_children}>
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <div className="contestName">
                <b style={{ fontSize: "18px" }}>{rname}</b>
              </div>
            )}
            <img
              src={image}
              alt="bull/bear"
              className={styles.Tradathon__LiveCard_image}
            />
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "100%" }} />
            ) : (
              <div className={styles.progressholder}>
                <div
                  className={styles.progressbar}
                  style={{ width: `${(joinedMembers / noOfPlayers) * 100}%` }}
                ></div>
              </div>
            )}
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <>
                {rstatus === 0 ? (
                  <Countdown date={startTime} renderer={renderer} />
                ) : (
                  <Countdown date={endTime} renderer={renderer} />
                )}
                {/* <p style={{ color: "#E5646E" }}>
          {moment(startTime).format("MMMM Do YYYY, h:mm:ss a")}
        </p> */}
              </>
            )}
            {/* <button
              className="TradathonRoom__join__button"
              style={{
                background: "rgba(69, 170, 67, 1)",
                borderRadius: "5px",
              }}
              onClick={() => {
                if (!tradathonLoading) {
                  joinRoom({
                    rcode: rcode,
                    pid: userData.profile_data._id,
                  });
                }
              }}
            >
              &nbsp;JOIN&nbsp;
            </button> */}
          </div>
          <div className={styles.Tradathon__LiveCard_children}>
            {tradathonLoading ? (
              <>
                <div className="skeleton text" style={{ width: "150px" }} />
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                <Badge
                  name={rstatus === 0 ? "Upcoming" : "Live"}
                  color={rstatus === 1 && "#45AA43"}
                  setAnimation={rstatus === 1 ? true : false}
                />
                {rstatus === 0 && (
                  <span
                    style={{ paddingLeft: "10px", cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation();
                      history.push(`/tradathon/room/share?rcode=${rcode}`);
                    }}
                  >
                    <BiShareAlt />
                  </span>
                )}
              </div>
            )}
            {tradathonLoading ? (
              <>
                <div className="skeleton text" style={{ width: "150px" }} />
              </>
            ) : (
              <p>Entry Fee: {entryFees}</p>
            )}
            {tradathonLoading ? (
              <div className="skeleton text" style={{ width: "150px" }} />
            ) : (
              <p style={{ color: "#717171" }}>Max: {noOfPlayers}</p>
            )}
            {listingTab === "live" && (
              <>
                {tradathonLoading ? (
                  <div className="skeleton text" style={{ width: "150px" }} />
                ) : (
                  <p
                    style={{
                      color:
                        rstatus !== 0
                          ? isPaid
                            ? "#45AA43"
                            : "#e8bd6e"
                          : rstatus === 0
                          ? isPaid
                            ? "#45AA43"
                            : "rgb(233, 56, 72)"
                          : "#e8bd6e",
                    }}
                  >
                    {rstatus !== 0
                      ? isPaid
                        ? "PAID"
                        : "SPECTATOR"
                      : rstatus === 0
                      ? isPaid
                        ? "PAID"
                        : "UNPAID"
                      : "SPECTATOR"}
                  </p>
                )}
              </>
            )}
          </div>
          <div className={styles.mobile__view}>
            <div>
              {tradathonLoading ? (
                <div className="skeleton text" style={{ width: "150px" }} />
              ) : (
                <p>Prize :{prize}</p>
              )}
              {tradathonLoading ? (
                <div className="skeleton text" style={{ width: "150px" }} />
              ) : (
                <p style={{ color: "#717171" }}>
                  {noOfPlayers - joinedMembers} left
                </p>
              )}
              {tradathonLoading ? (
                <div className="skeleton text" style={{ width: "150px" }} />
              ) : (
                <p style={{ color: "#E8BD6E" }}>{rtype}</p>
              )}
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-end",
              }}
            >
              {tradathonLoading ? (
                <>
                  <div className="skeleton text" style={{ width: "150px" }} />
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <Badge
                    name={rstatus === 0 ? "Upcoming" : "Live"}
                    color={rstatus === 1 && "#45AA43"}
                    setAnimation={rstatus === 1 ? true : false}
                  />
                  {rstatus === 0 && (
                    <span
                      style={{ paddingLeft: "10px", cursor: "pointer" }}
                      onClick={(e) => {
                        e.stopPropagation();
                        history.push(`/tradathon/room/share?rcode=${rcode}`);
                      }}
                    >
                      <BiShareAlt />
                    </span>
                  )}
                </div>
              )}
              {tradathonLoading ? (
                <>
                  <div className="skeleton text" style={{ width: "150px" }} />
                </>
              ) : (
                <p>Entry Fee: {entryFees}</p>
              )}
              {tradathonLoading ? (
                <div className="skeleton text" style={{ width: "150px" }} />
              ) : (
                <p style={{ color: "#717171" }}>Max: {noOfPlayers}</p>
              )}
              {listingTab === "live" && (
                <>
                  {" "}
                  {tradathonLoading ? (
                    <div className="skeleton text" style={{ width: "150px" }} />
                  ) : (
                    <p
                      style={{
                        color:
                          rstatus !== 0
                            ? isPaid
                              ? "#45AA43"
                              : "#e8bd6e"
                            : rstatus === 0
                            ? isPaid
                              ? "#45AA43"
                              : "rgb(233, 56, 72)"
                            : "#e8bd6e",
                      }}
                    >
                      {rstatus !== 0
                        ? isPaid
                          ? "PAID"
                          : "SPECTATOR"
                        : rstatus === 0
                        ? isPaid
                          ? "PAID"
                          : "UNPAID"
                        : "SPECTATOR"}
                    </p>
                  )}
                </>
              )}
            </div>
          </div>
          {tradathonLoading ? (
            <div className="shimmer-wrapper">
              <div className="shimmer"></div>
            </div>
          ) : (
            <></>
          )}{" "}
        </div>
        <h4 style={{ margin: "20px 5px" }}>
          Amount would be distributed as follows:
        </h4>
        {!winnings || !winnings.length > 0 ? (
          <Loader />
        ) : (
          <center>
            <table
              className="Home__MainTable"
              style={{
                marginTop: "10px",
                background: "#EFF2F5",
                width: width > 1000 ? "50%" : "90%",
              }}
            >
              <thead>
                <tr>
                  <th>
                    <div
                      className="Home__MainTable-th"
                      style={{ justifyContent: "center" }}
                    >
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Rank </div>
                      </div>
                    </div>
                  </th>
                  <th>
                    <div
                      className="Home__MainTable-th"
                      style={{ justifyContent: "center" }}
                    >
                      <div
                        style={{
                          color: "white",
                        }}
                        className="Home__MainTable__pct"
                      >
                        &nbsp;
                        <div style={{ cursor: "pointer" }}>Winnings</div>
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {winnings && winnings.length > 0 ? (
                  winnings.map((c, index) => (
                    <>
                      <tr key={index} className="Home__MainTable__link">
                        <td style={{ textAlign: "center" }}>{c.range}</td>

                        <td>
                          <div
                            className="Home__MainTable-td"
                            style={{ justifyContent: "center" }}
                          >
                            <p
                              style={{
                                marginRight: "5px",
                                whiteSpace: "nowrap",
                                cursor: "pointer",
                              }}
                            >
                              <NumberFormat
                                value={formatPrice(c.amt)}
                                displayType={"text"}
                                thousandSeparator={true}
                                prefix="₹"
                              />
                            </p>
                          </div>
                        </td>
                      </tr>
                    </>
                  ))
                ) : (
                  <></>
                )}
              </tbody>
            </table>
          </center>
        )}

        {/* )} */}
        <div
          className="TradathonRoom__terms"
          style={{ justifyContent: "center" }}
        >
          <input type="checkbox" onChange={handleTerms} checked={terms} />I
          Accept Terms & Condition
        </div>
        <center>
          {" "}
          <button
            className="TradathonRoom__join__button"
            style={{
              background: "rgba(69, 170, 67, 1)",
              borderRadius: "5px",
              marginBottom: "10px",
            }}
            onClick={() => handleJoin()}
          >
            &nbsp;JOIN&nbsp;{" "}
            {tradathonLoading ? (
              <div
                className="loader1"
                style={{
                  position: "absolute",
                  zIndex: 3,
                  top: "40%",
                  left: "40%",
                }}
              ></div>
            ) : (
              <></>
            )}
          </button>
        </center>
      </div>
    </div>
  );
};

export default withRouter(PublicContestModal);
